import { Outlet } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CallNowFAB from "@/components/CallNowFAB";

export default function Layout() {
  return (
    <div className="min-h-screen bg-ivory text-ink grain">
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
      <CallNowFAB />
    </div>
  );
}
